import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CitationRefNavCommand from './citationrefnavcommand';

export default class CitationRefNavUI extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'citationrefnav', new CitationRefNavCommand( editor ) );
  }
}
